import { ADD_TODO_HANDLER } from "../../constants";

export const TodoHandler = (inputs) => async (dispatch) => {
  dispatch({
    type: ADD_TODO_HANDLER,
    payload: { attributes: inputs },
  });
};
